import { useEffect, useState } from "react";
import {
    getBranchUserRoles,
    createBranchUserRole,
    updateBranchUserRole,
    deleteBranchUserRole
} from "../../api/role.api";
import "./RoleModal.css"

export default function RoleModal({ branchId, onClose }) {

    const [roles, setRoles] = useState([]);
    const [name, setName] = useState("");
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        loadRoles();
    }, []);

    const loadRoles = async () => {
        const data = await getBranchUserRoles(branchId);
        setRoles(data);
    };

    const handleSubmit = async () => {
        if (!name.trim()) return;

        if (editingId) {
            await updateBranchUserRole(editingId, {
                name,
                branch_id: branchId
            });
        } else {
            await createBranchUserRole({
                name,
                branch_id: branchId
            });
        }

        setName("");
        setEditingId(null);
        loadRoles();
    };

    const handleEdit = (role) => {
        setName(role.name);
        setEditingId(role.id);
    };

    const handleDelete = async (id) => {
        await deleteBranchUserRole(id);
        loadRoles();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Manage Roles</h3>
                <div className="role-form">
                    <input
                        type="text"
                        placeholder="Role name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <button className="btn btn-primary" onClick={handleSubmit}>
                        {editingId ? "Update" : "Create"}
                    </button>
                </div>


                <table className="role-table">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {roles.map((role) => (
                        <tr key={role.id}>
                            <td>{role.name}</td>
                            <td>
                                <button
                                    className="btn btn-edit"
                                    onClick={() => handleEdit(role)}
                                >
                                    Edit
                                </button>
                                <button
                                    className="btn btn-delete"
                                    onClick={() => handleDelete(role.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <button className="btn btn-close" onClick={onClose}>
                    Close
                </button>

            </div>
        </div>
    );
}
